import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://7d606e947b537b913a0c59f862d8e955@o4508089669648384.ingest.de.sentry.io/4508320085114960",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});